<template>
  <div></div>
</template>

<script>
export default {
  data({ $route }) {
    return {
      ...$route,
    };
  },
  mounted() {
    const userAgent = navigator.userAgent;
    // const visitTime = new Date().getTime();
    if (userAgent.match(/Android/i)) {
      //안드로이드일 때
      location.href = "intent://daeguro#Intent;scheme=daeguro;package=com.insungdata.daegudelivery;end";
    }
    else if (userAgent.match(/iPhone/i)) {
      //아이폰일 때
      setTimeout(function () {
        if (confirm("앱 설치 페이지로 이동하시겠습니까?")) {
          location.href = "https://apps.apple.com/kr/app/id1572960675";
        }
      }, 2000);
      location.href = "daeguro://daeguro";
    }
    else {
      if (this.params.type === "ios") {
        window.open("https://apps.apple.com/kr/app/id1572960675");
      } 
      else {
        window.open("https://play.google.com/store/apps/details?id=com.insungdata.daegudelivery");
      }
    }
    if (document.referrer) {
      this.$router.go(-1);
    } 
    else {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>

<style scoped>
</style>